import { testDataCreator } from '@wix/answers-lib';
import { CallActionType } from '../call-action';
export var ivrFlowBuilder = testDataCreator(function () { return ({
    id: 'b00b0b0b-b0b00b0b-0b0b0b0b0-0b0b0b0',
    name: 'Bob IVR',
    totalConnectedLines: 0,
    messages: [],
    action: {
        type: CallActionType.HANGUP
    },
    creationDate: Date.now(),
    lastUpdateDate: Date.now(),
}); });
//# sourceMappingURL=ivr-flow.builder.js.map